export enum DisclaimerDisplayType {
    superscript = 'superscript',
    tooltip = 'tooltip',
    inline = 'inline',
}



// WEBPACK FOOTER //
// ./src/models/configuration/disclaimers/DisclaimerDisplayType.ts